import { IColumns } from '../../../../../../components/Dashboard/TableSmall'

export interface IData {
  request: string
  columns: IColumns[]
}

export interface IResultDataItem {
  fiatCurrencies: string
  cryptoCurrencies: string
}

export interface IIncomingDataItem {
  asset: string
  amount: string
  isCurrencyCrypto: boolean
}

export const data: IData = {
  request: '/trading/balance/treasury',
  columns: [
    {
      id: 'fiatCurrencies',
      label: 'FIAT CURRENCIES',
    },
    {
      id: 'cryptoCurrencies',
      label: 'CRYPTO CURRENCIES',
    },
  ],
}
